import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M28.333 1.6H1.667v20.8h26.666zM1.667 0C.747 0 0 .716 0 1.6v20.8c0 .884.746 1.6 1.667 1.6h26.666c.92 0 1.667-.716 1.667-1.6V1.6c0-.884-.746-1.6-1.667-1.6z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M15 5.6c.46 0 .834.358.834.8v11.2c0 .441-.373.8-.834.8s-.833-.359-.833-.8V6.4c0-.442.373-.8.833-.8",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M8.335 12c0-.442.373-.8.833-.8h11.667c.46 0 .833.358.833.8s-.373.8-.833.8H9.168c-.46 0-.833-.358-.833-.8",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }